

















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class PresetCreateModal extends Vue {
  presetName: string = "";

  show() {
    this.presetName = "";
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  create() {
    this.$emit("ok", this.presetName);
    this.hide();
  }
}
